import { create } from "zustand";

/** One affected booking inside the structured 409 the backend emits
 *  when ``apply_table_moves`` is asked to relocate a pinned booking
 *  in a way that breaks its pin contract. The staff modal renders one
 *  row per entry so the operator sees exactly who gets moved off-pin.
 *
 *  Mirrors ``backend/apps/reservations/services/transitions.py::
 *  PinOverrideRequiredError`` + the view's
 *  ``_pin_override_blocked_payload``. */
export interface PinOverrideBlocked {
  reservation_id: string;
  guest_name: string | null;
  pin_level: "zone" | "table";
}

export interface PinOverrideContext {
  blocked: PinOverrideBlocked[];
}

interface PendingOverride {
  context: PinOverrideContext;
  resolve: (acknowledge: boolean) => void;
}

interface State {
  pending: PendingOverride | null;
  open: (context: PinOverrideContext) => Promise<boolean>;
  close: (acknowledge: boolean) => void;
}

export const usePinOverrideStore = create<State>((set, get) => ({
  pending: null,
  open: (context) =>
    new Promise<boolean>((resolve) => {
      set({ pending: { context, resolve } });
    }),
  close: (acknowledge) => {
    const { pending } = get();
    if (pending) {
      pending.resolve(acknowledge);
      set({ pending: null });
    }
  },
}));
